<div class="hospitality-link-presenter" *ngIf="hasLinks" [ngClass]="variantClass">
  <ng-container *ngFor="let link of links; trackBy: trackByIndex">
    <ng-container *ngIf="getLinkUrl(link) as linkUrl; else staticCard">
      <a
        class="hospitality-link-card"
        [class.hospitality-link-card--document]="!!link.document"
        [href]="linkUrl"
        [attr.target]="shouldOpenInNewTab(linkUrl) ? '_blank' : null"
        rel="noopener"
        (click)="onLinkClick($event, link)"
      >
        <ng-container *ngTemplateOutlet="cardContent; context: { $implicit: link }"></ng-container>
      </a>
    </ng-container>
    <ng-template #staticCard>
      <div
        class="hospitality-link-card"
        [class.hospitality-link-card--document]="!!link.document"
      >
        <ng-container *ngTemplateOutlet="cardContent; context: { $implicit: link }"></ng-container>
      </div>
    </ng-template>
  </ng-container>
</div>

<ng-template #cardContent let-link>
  <div class="hospitality-link-card__preview" *ngIf="link.document; else iconOnly">
    <img
      nz-image
      *ngIf="isImageDocument(link) && getImageSource(link) as imageSrc"
      [nzSrc]="imageSrc"
      [attr.alt]="resolveLabel(link)"
      [nzDisablePreview]="true"
      class="hospitality-link-card__image"
    />
    <ng-container *ngIf="!isImageDocument(link)">
      <i nz-icon [nzType]="getIconType(link)" class="hospitality-link-card__icon" aria-hidden="true"></i>
      <span class="hospitality-link-card__extension" *ngIf="getDocumentExtension(link)">
        {{ getDocumentExtension(link) | uppercase }}
      </span>
    </ng-container>
  </div>
  <ng-template #iconOnly>
    <div class="hospitality-link-card__preview hospitality-link-card__preview--icon">
      <i nz-icon [nzType]="getIconType(link)" class="hospitality-link-card__icon" aria-hidden="true"></i>
    </div>
  </ng-template>
  <div class="hospitality-link-card__body">
    <div class="hospitality-link-card__label">
      {{ resolveLabel(link) }}
    </div>
    <div class="hospitality-link-card__meta" *ngIf="link.address">
      {{ link.address }}
    </div>
  </div>
</ng-template>
